<template>
  <div class="row base-header">
    <span class="align-middle"> {{ headerLabel }} </span>
  </div>
</template>

<script>
export default {
  name: "BaseHeader",
  data() {
    return {};
  },
  props: {
    headerLabel: {
      type: String,
      default: "false"
    }
  }
};
</script>
